import script from "./AdvisorServiceRequirementsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvisorServiceRequirementsIndex.vue?vue&type=script&setup=true&lang=js"

import "./AdvisorServiceRequirementsIndex.vue?vue&type=style&index=0&id=b261c090&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b261c090"]])

export default __exports__